import { render, staticRenderFns } from "./App.vue?vue&type=template&id=b993e780&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=b993e780&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../55/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b993e780",
  null
  
)

export default component.exports